import { DataGrid, GridColDef, GridToolbarFilterButton } from '@mui/x-data-grid';
import React, { useEffect, useState } from "react";
import Moment from 'moment';
import { UsersModel } from '../../models/UsersModel';
import { Box, Button, IconButton, Link, SelectChangeEvent, FormControl, Select, MenuItem, Grid, LinearProgress, TextField, Autocomplete, Tooltip } from '@mui/material';
import { config } from '../../Constants';
import RestoreFromTrashIcon from '@mui/icons-material/RestoreFromTrash';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { AddEditUsers } from '../AddEdit/AddEditUsers';
import useAuth from "../../context/AuthProvider";
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { RiExpandUpDownLine } from "react-icons/ri";
import { apiClient } from '../../helper/api';
import { AppFlags } from '../../helper/config';
import { AddEditCustomerUsers } from '../AddEdit/AddEditCustomerUsers';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { SelectProps } from '@mui/material/Select';
import { writeXlsxFile, formatUtcToLocal } from '../../helper/utils';
import { Close } from "@mui/icons-material";
import FileDownload from '@mui/icons-material/FileDownload';
import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
interface Iprops {
    UsersCL: UsersModel[],
    fetchData: () => void
    sortModel: any;
    setSortModel: React.Dispatch<React.SetStateAction<any>>
}


export const ClientUserRoles: string[] = [
    "Client Admin", 
    "Client Processors", 
    "State Reporter", 
    "Diligent Search User"
];

const DILIGENT_SEARCH_ALLOWED_CLIENT_KEYWORDS = [
    "ally",
    "intrepid",
    "brooks",
    "cardigan",
    "intercontinental",
    "worldwide",
    "venbrook",
    "youth",
];

const normalizeName = (value: string = "") => value.toLowerCase().trim();

const isDiligentSearchEligibleClientName = (clientName: string = ""): boolean => {
    const normalizedClientName = normalizeName(clientName);
    return DILIGENT_SEARCH_ALLOWED_CLIENT_KEYWORDS.some((keyword) => normalizedClientName.includes(keyword));
};

export const CustomerUsersList: React.FC<Iprops> = ({ UsersCL, fetchData, sortModel, setSortModel }) => {
    const [rows, setRows] = React.useState(UsersCL);
    const [displayedUsers, setDisplayedUsers] = React.useState(UsersCL);
    const [selectedClient, setSelectedClient] = React.useState<number>(0);
    const [selectedUserType, setSelectedUserType] = React.useState<string>("");
    const [selectedStatus, setSelectedStatus] = React.useState<string>("");
    const [partners, setPartners] = React.useState<{ partnersId: number; customerName: string }[]>([]);
    
    const initialUserData: UsersModel = {
        userId: 0,
        userName: "",
        password: "",
        isActive: true,
        isDeleted: false,
        dateCreated: new Date(),
        datemodified: new Date(),
        userEmail: "",
        firstName: "",
        lastName: "",
        modifiedBy: 0,
        createdBy: 0,
        roleIds: "",
        partnersId: 0,
        userRoles: '',
        customerName: '',
        // profilePicture: '',

    }


    const [Open, setOpen] = React.useState(false);
    const [loadingPartner, setloadingPartner] = React.useState(true);
    const [Formdata, setFormData] = React.useState(initialUserData);
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    }
    const { user } = useAuth();
    const token = user?.token;
    const [users, setUsers] = React.useState([])
    const [loading, setloading] = React.useState(false);

    const baseClientUserRolesForUi: string[] = AppFlags.enableStateReports
        ? ClientUserRoles
        : ClientUserRoles.filter((r: string) => r !== "State Reporter");
    const selectedClientName = partners.find((p) => p.partnersId === selectedClient)?.customerName || "";
    const showDiligentSearchRoleInFilters = selectedClient > 0 && isDiligentSearchEligibleClientName(selectedClientName);
    const filterUserRolesForUi: string[] = baseClientUserRolesForUi.filter((role) => {
        if (role !== "Diligent Search User") return true;
        return showDiligentSearchRoleInFilters;
    });

    useEffect(() => {
        if (selectedUserType !== "Diligent Search User") return;
        if (!showDiligentSearchRoleInFilters) {
            setSelectedUserType("");
        }
    }, [selectedUserType, showDiligentSearchRoleInFilters]);

    const getpartnerfetch = () => {
        setloading(true);

        apiClient('/Users/getLoggedInUserPartnerId',
            {
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((res) => {
                const roles = (user?.userRoles || '')
                    .split(',')
                    .map(r => r.trim())
                    .filter(Boolean);
                const skipSinglePartnerSeed =
                    roles.includes('Super Admin') ||
                    roles.includes('MISC Filer') ||
                    roles.includes('Client Admin') ||
                    roles.includes('Client Processors');
                initialUserData.partnersId = skipSinglePartnerSeed ? 0 : Number(res.data);
                setFormData({ ...initialUserData });
                setOpen(true);
                setloadingPartner(false);
            }).finally(() => {
                setloading(false);
            });


    }

    useEffect(() => {
        // getpartnerfetch();
        fetchPartners();
    }, [])

    useEffect(() => {
        setDisplayedUsers(UsersCL);
    }, [UsersCL])

    useEffect(() => {
        fetchUsersWithFilters();
    }, [selectedClient, selectedUserType, selectedStatus])

    const fetchPartners = () => {
        apiClient('/Partners/getPartners', {
            method: "GET",
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            })
        })
        .then((responseJson) => {
            if (!responseJson) return;
            setPartners(responseJson.data || []);
        })
        .catch((error) => {
            console.error("Error fetching partners:", error);
        });
    };


    const fetchUsersWithFilters = () => {
        setloading(true);
        
        // Build query parameters
        let queryParams = 'isCustomerUser=true';
        
        if (selectedClient > 0) {
            queryParams += `&partnersId=${selectedClient}`;
        }
        
        if (selectedUserType) {
            queryParams += `&userRole=${encodeURIComponent(selectedUserType)}`;
        }
        
        if (selectedStatus === '') {
            queryParams += `&isActive=null`;
        } else {
            queryParams += `&isActive=${selectedStatus === "Active" ? "true" : "false"}`;
        }

        apiClient(`/Users/getAllUsers?${queryParams}`, {
            method: "GET",
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            })
        })
        .then((res) => {
            if (!res) return;
            setDisplayedUsers(res.data || []);
        })
        .catch((error) => {
            console.error("Error fetching users:", error);
            setDisplayedUsers([]);
        })
        .finally(() => {
            setloading(false);
        });
    };

    const handleClearFilters = () => {
        setSelectedClient(0);
        setSelectedUserType("");
        setSelectedStatus("");
        // The useEffect will trigger fetchUsersWithFilters when these values change
    };

    const handleExportXlsx = async () => {
        try {
            setloading(true);
            
            // Build query parameters with all current filters
            let queryParams = 'isCustomerUser=true';
            
            if (selectedClient > 0) {
                queryParams += `&partnersId=${selectedClient}`;
            }
            
            if (selectedUserType) {
                queryParams += `&userRole=${encodeURIComponent(selectedUserType)}`;
            }
            
            if (selectedStatus === '') {
                queryParams += `&isActive=null`;
            } else {
                queryParams += `&isActive=${selectedStatus === "Active" ? "true" : "false"}`;
            }

            // Call API to fetch all filtered data
            const res = await apiClient(`/Users/getAllUsers?${queryParams}`, {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            });

            const allData: UsersModel[] = res?.data || [];

            if (!allData || allData.length === 0) {
                Swal.fire({
                    icon: 'info',
                    title: 'No Data',
                    text: 'No data available to export',
                    confirmButtonText: 'OK'
                });
                setloading(false);
                return;
            }

            const fieldsToExport: (keyof UsersModel)[] = [
                'firstName', 'lastName', 'userName', 'userEmail', 
                'dateCreated', 'userRoles', 'customerName', 'isActive'
            ];

            const capitalizeFirstLetter = (str: string) => {
                return str.charAt(0).toUpperCase() + str.slice(1).replace(/([A-Z])/g, ' $1').trim();
            };

            const formattedValues = allData.map((item: UsersModel) => {
                return fieldsToExport.map((key: keyof UsersModel) => {
                    const value = item[key];
                    if (key === 'dateCreated' && value) {
                        return formatUtcToLocal(value as string | Date, "YYYY-MM-DD");
                    }
                    if (key === 'isActive') {
                        return value === true ? "Active" : "InActive";
                    }
                    return value || '';
                });
            });

            const headers = fieldsToExport.map(field => capitalizeFirstLetter(field));

            const exportData = [
                headers,
                ...formattedValues
            ];

            writeXlsxFile(exportData, "ClientUsers");
        } catch (error) {
            console.error("Error exporting data:", error);
            Swal.fire({
                icon: 'error',
                title: 'Export Error',
                text: 'Failed to export data',
                confirmButtonText: 'OK'
            });
        } finally {
            setloading(false);
        }
    };
    const [selectedOptions, setSelectedOption] = React.useState<string[] | string>([]);
    function EditToolbar() {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    gap: 1.5,
                    px: 2,
                    py: 1,
                    minHeight: 48,
                    borderBottom: '1px solid #e2e8f0',
                    backgroundColor: '#fafbfc',
                }}
            >
                <Button
                    variant="contained"
                    size="medium"
                    onClick={handleExportXlsx}
                    startIcon={<FileDownload />}
                    title="Export"
                    sx={{
                        textTransform: 'none',
                        fontWeight: 600,
                        backgroundColor: '#2099d2',
                        // color: '#2099d2',
                        '&:hover': {
                            backgroundColor: '#176990',
                            // backgroundColor: 'rgba(32, 153, 210, 0.04)',
                            // color: '#176990',
                        },
                        px: 2,
                    }}
                >
                    Export
                </Button>
            </Box>
        );
    }

    const columns: GridColDef[] = [

        {
            field: 'firstName', type: 'string', headerName: 'First Name', hideSortIcons: true, minWidth: 140,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'firstName'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div >
                        <span className="table-card-title word-wrap-1 p-0">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, flex: 0.8, headerAlign: 'left', align: 'left'
        },
        {
            field: 'lastName', type: 'string', headerName: 'Last Name', flex: 0.8, hideSortIcons: true, minWidth: 140,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'lastName'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div >
                        <span className="table-card-title word-wrap-1 p-0">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, headerAlign: 'left', align: 'left'
        },
        {
            field: 'userName', headerName: 'Username', width: 130, flex: 0.8, hideSortIcons: true, minWidth: 140,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'userName'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div >
                        <span className="table-card-title word-wrap-1 p-0">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, headerAlign: 'left', align: 'left'
        },
        {
            field: 'userEmail', type: 'string', headerName: 'Email ', flex: 1, hideSortIcons: true, minWidth: 150,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'userEmail'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div >
                        <span className="table-card-title word-wrap-1 p-0">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, headerAlign: 'left', align: 'left'
        },
        {
            field: 'dateCreated', type: 'date', headerName: 'Created Date ', hideSortIcons: true, minWidth: 150,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'dateCreated'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div >
                        <span className="table-card-title word-wrap-1 p-0">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, headerAlign: 'left', align: 'left', flex: 0.8, renderCell: (params) => (<div> {params.row.dateCreated ? formatUtcToLocal(params.row.dateCreated, "YYYY-MM-DD") : ""}</div>)
        },
        {
            field: 'userRoles', type: 'string', headerName: 'User Type', flex: 1, hideSortIcons: true, minWidth: 150,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'userRoles'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div >
                        <span className="table-card-title word-wrap-1 p-0">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, headerAlign: 'left', align: 'left'
        },
        {
            field: 'customerName', type: 'string', headerName: 'Client/Partner', flex: 1, hideSortIcons: true, minWidth: 160,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'customerName'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div >
                        <span className="table-card-title word-wrap-1 p-0">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, headerAlign: 'left', align: 'left'
        },

        {
            field: 'isActive', type: 'text', headerName: 'Active user', flex: 0.6, hideSortIcons: true, minWidth: 140,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'isActive'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div >
                        <span className="table-card-title word-wrap-1 p-0">{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, headerAlign: 'left', align: 'left', 
            valueGetter: (params) => {
                return params.row.isActive === true ? "Active" : "InActive";
            },
            renderCell: (params) => (
                params.row.isActive === true ? "Active" : "InActive")
        },
        {
            field: 'userId', flex: 1, headerAlign: 'center', align: 'center', headerName: "Action", sortable: false, hideSortIcons: true, maxWidth: 100, minWidth: 100,
            filterable: false, 
            disableColumnMenu: true,
            disableExport: true,
            renderCell: (params) => (<div>

                <IconButton
                    color="primary"
                    onClick={() => { handleEdit(params.row) }}
                    sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(32,153,210,0.15) !important' } }}
                >
                    <Tooltip
                        title="Edit"
                        placement="top"
                        arrow
                    >
                        <EditOutlinedIcon fontSize="medium" color="primary" />
                    </Tooltip>

                </IconButton >
                {user?.userRoles.split(",").includes("Super Admin") || user?.userRoles.split(",").includes("Client Accounting") || user?.userRoles.split(",").includes("Client Admin") ?
                    <IconButton
                        color="error"
                        onClick={() => { handleDelete(params.row.userId) }}
                        sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(211,48,47,0.15) !important' } }}
                    >
                        {params.row.isDeleted ? <RestoreFromTrashIcon fontSize="medium" color="success" /> :  
                        <Tooltip
                            title="Delete"
                            placement="top"
                            arrow
                        >
                            <DeleteOutlineOutlinedIcon fontSize="medium" color="error" />
                        </Tooltip>
                        }
                    </IconButton >
                    : ""}
            </div>)
        },
    ];

    const handleClickOpen = () => {
        {
            (user?.userRoles.split(",").includes("Super Admin") || user?.userRoles.split(",").includes("MISC Filer")) ?
                setSelectedOption([])
                : setSelectedOption(["6"])
        }
        getpartnerfetch();
    };
    const [SelectedRoles, setSelectedRoles] = React.useState<string[] | string>([]);
    const handleClose = () => {
        setFormData(initialUserData);
        setSelectedOption([]);
        setImageProfile('');
        setOpen(false);
    };
    const handleSubmit = () => {
        fetchData();
        setOpen(false);
        handleClearFilters();

    };
    const [imageProfile, setImageProfile] = useState<string>("");
    const handleEdit = (ILobData: UsersModel) => {

        
        const commaSeparatedIds: string[] = ILobData.roleIds?.split(',') || [];
      
        const RoleIds: number[] = commaSeparatedIds.map(id => Number(id));


        let CheckData: UsersModel = {
            userEmail: ILobData.userEmail,
            firstName: ILobData.firstName,
            lastName: ILobData.lastName,
            roleIds: RoleIds.toString(),
            userId: ILobData.userId,
            dateCreated: new Date(),
            partnersId: 0,
            // profilePicture: ILobData.profilePicture,
        }

        // setFormData(CheckData);
        let abc = ILobData.roleIds?.split(',') ?? [];
        let f = abc.map(e => e.trim());
    
        setSelectedRoles(f);
        setSelectedOption(f);
        ILobData.password = "";
        setFormData(ILobData);
        // setImageProfile(ILobData.profilePicture ?? "");
        setOpen(true);
     
    };


    const handleDelete = (id: number) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            // icon: null, // Remove the icon property
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        })
            .then((result) => {
                if (result.isConfirmed) {
                    apiClient("/Users/Delete?id=" + `${id}`,
                        {
                            headers: new Headers({
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                            }),
                            method: "Delete",
                        }
                    )
                        .then((res) => {
                            if (!res) return
                            fetchData();
                            setOpen(false);
                        })
                    Swal.fire(
                        'Deleted!',
                        'Your file has been deleted.',
                        'success'
                    )
                }
            })
        //call api to save data
        // fetch(config.url.API_URL + "/Users/Delete?id=" + `${id}`,
        //     {
        //         headers: new Headers({
        //             'Content-Type': 'application/json',
        //             'Authorization': `Bearer ${token}`,
        //         }),
        //         method: "Delete",
        //     }
        // )
        //     .then((response) => {
        //         if (response.ok) {
        //             return response.json();
        //         }
        //         throw new Error('Something went wrong');
        //     })
        //     .then((res) => {
        //         alert("Data Successfully Deleted")
        //         fetchData();
        //         setOpen(false);
        //     }).catch((error) => {
        //         console.log(error)
        //     });


    };


    const showFiltersSection = user?.userRoles.split(",").includes("MISC Filer") || user?.userRoles.split(",").includes("MISC State Reporter") || user?.userRoles.split(",").includes("Super Admin") || user?.userRoles.split(",").includes("Customer User");

    const FMSelectClient: React.FC<SelectProps> = ({ variant, ...props }) => {
        return (
            <FormControl fullWidth>
                <Autocomplete
                    sx={{
                        marginTop: '-4px !important',
                        '& .MuiAutocomplete-input': { padding: '0px 4px 0px 5px !important' },
                    }}
                    options={partners}
                    getOptionLabel={(option) => option.customerName}
                    onChange={(event, value) => setSelectedClient(value?.partnersId ?? 0)}
                    value={partners.find((p) => p.partnersId === selectedClient) ?? null}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Client"
                            sx={{
                                '.MuiFormLabel-root.Mui-focused': {
                                    color: (typeof params.inputProps.value === 'string' && params.inputProps.value.length > 0) ? '#000' : '#cccccc !important',
                                },
                                '& .MuiInputBase-root': { marginTop: '5px !important' },
                                '& .MuiOutlinedInput-root': { padding: '4.5px 9px' },
                                '& .MuiFormLabel-root': { transform: 'translate(14px, 13px) scale(1)' },
                                '& .MuiInputLabel-shrink': { transform: 'translate(14px, -2px) scale(0.75)' },
                            }}
                            InputLabelProps={{
                                ...params.InputLabelProps,
                                shrink: selectedClient > 0 || (typeof params.inputProps.value === 'string' && params.inputProps.value.length > 0),
                            }}
                        />
                    )}
                />
            </FormControl>
        );
    };

    const FMSelectUserType: React.FC<{ roles: string[] }> = ({ roles }) => {
        const handleUserTypeChange = (event: SelectChangeEvent<string>) => {
            setSelectedUserType(event.target.value);
        };

        return (
            <FormControl fullWidth>
                <Select
                    onChange={handleUserTypeChange}
                    value={selectedUserType}
                    size="small"
                    label={null}
                    className="border-round"
                    IconComponent={ExpandMoreIcon}
                    displayEmpty
                    sx={{
                        "& .MuiOutlinedInput-notchedOutline": { borderColor: "#c4c4c4" },
                        "& .MuiInputBase-root": { marginTop: '1px !important' },
                        "& .MuiInputBase-input": { padding: '7px 14px !important' },
                    }}
                >
                    <MenuItem value={""}>
                        User Type
                    </MenuItem>
                    {roles.map((userType, key) => (
                        <MenuItem
                            key={key}
                            value={userType}
                        >
                            {userType}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        );
    };

    const FMSelectStatus: React.FC<SelectProps> = ({ variant, ...props }) => {
        const handleStatusChange = (event: SelectChangeEvent<string>) => {
            setSelectedStatus(event.target.value);
        };

        return (
            <FormControl fullWidth>
                <Select
                    onChange={handleStatusChange}
                    value={selectedStatus}
                    size="small"
                    label={null}
                    className="border-round"
                    IconComponent={ExpandMoreIcon}
                    displayEmpty
                    sx={{
                        "& .MuiOutlinedInput-notchedOutline": { borderColor: "#c4c4c4" },
                        "& .MuiInputBase-root": { marginTop: '1px !important' },
                        "& .MuiInputBase-input": { padding: '7px 14px !important' },
                    }}
                >
                    <MenuItem value={""}>
                        Status
                    </MenuItem>
                    <MenuItem value={"Active"}>
                        Active
                    </MenuItem>
                    <MenuItem value={"InActive"}>
                        InActive
                    </MenuItem>
                </Select>
            </FormControl>
        );
    };

    return (
        <>
            <div style={{ position: "fixed", top: "0", left: "0", zIndex: "9990", width: "100%" }}>
                {loading && <LinearProgress color="info" sx={{ backgroundColor: "#132D3D" }} />}
            </div>
            {/* Top bar: same structure as RemovedQueue for smooth filter collapse */}
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 1.5,
                    px: { xs: 4, lg: 2 },
                    py: 2,
                    borderBottom: '1px solid #e2e8f0',
                    backgroundColor: '#fafbfc',
                    minHeight: 56,
                    mb: showFiltersSection ? 0 : 3,
                    marginLeft: { xs: '-24px', sm: '0px' },
                    marginRight: { xs: '-24px', sm: '0px' },
                }}
            >
                <h4 className="d-flex card-title" style={{ fontWeight: 600, fontSize: '0.9375rem', color: '#334155' }}>Client Users</h4>
                {/* {showFiltersSection && <Box sx={{ flex: 1, minWidth: 120 }} />} */}
                <Button
                    variant="contained"
                    size="medium"
                    startIcon={<AddOutlinedIcon fontSize="small" />}
                    onClick={handleClickOpen}
                    sx={{
                        textTransform: 'none',
                        fontWeight: 600,
                        backgroundColor: '#2099d2',
                        '&:hover': { backgroundColor: '#176990' },
                        px: 2,
                    }}
                >
                    Add User
                </Button>
            </Box>
            {/* Filter panel (visible when user role allows filters) */}
            {showFiltersSection && (
                <Box
                    sx={{
                        width: '100%',
                        py: 2,
                        px: 2,
                    }}
                >
                    <Grid
                        container
                        spacing={2}
                        alignItems="center"
                        className="filter-grid"
                        display="flex"
                    >
                            <Grid item xl={2} lg={4} sm={6} xs={12}>
                                <FMSelectClient />
                            </Grid>
                            <Grid item xl={2} lg={4} sm={6} xs={12}>
                                <FMSelectUserType roles={filterUserRolesForUi} />
                            </Grid>
                            <Grid item xl={2} lg={4} sm={6} xs={12}>
                                <FMSelectStatus />
                            </Grid>
                            <Grid item>
                                <Button
                                    variant="outlined"
                                    size="medium"
                                    onClick={handleClearFilters}
                                    startIcon={<Close />}
                                    sx={{
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        borderColor: '#2099d2',
                                        color: '#2099d2',
                                        '&:hover': {
                                            borderColor: '#176990',
                                            backgroundColor: 'rgba(32, 153, 210, 0.04)',
                                            color: '#176990',
                                        },
                                        px: 2,
                                    }}
                                >
                                    Clear
                                </Button>
                            </Grid>
                            {/* <Grid item>
                                <Button
                                    variant="outlined"
                                    size="medium"
                                    onClick={handleExportXlsx}
                                    title="Export"
                                    sx={{
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        borderColor: '#2099d2',
                                        color: '#2099d2',
                                        '&:hover': {
                                            borderColor: '#176990',
                                            backgroundColor: 'rgba(32, 153, 210, 0.04)',
                                            color: '#176990',
                                        },
                                        px: 2,
                                    }}
                                >
                                    Export
                                </Button>
                            </Grid> */}
                    </Grid>
                </Box>
            )}
            <Box
                sx={{
                    height: "calc(100vh - 300px)",
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    backgroundColor: '#ffffff',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 24px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06)',
                    border: '1px solid #e2e8f0',
                }}
            >
                <DataGrid
                    getRowId={(r) => r.userId}
                    rows={displayedUsers}
                    columns={columns}
                    style={{ textAlign: 'center' }}
                    components={{
                        Toolbar: EditToolbar,
                    }}
                    sortModel={sortModel}
                    onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                    sx={{
                        fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                        border: 'none',
                        fontSize: '14px',
                        color: '#475569',
                        backgroundColor: '#ffffff',
                        // '& .MuiDataGrid-columnHeaderTitle': {
                        //     whiteSpace: 'normal',
                        //     lineHeight: 1.35,
                        //     fontWeight: 600,
                        //     fontSize: '12px',
                        //     letterSpacing: '0.05em',
                        //     // textTransform: 'uppercase',
                        //     color: '#64748b',
                        // },
                        '& .MuiDataGrid-columnHeaders': {
                            backgroundColor: '#f8fafc',
                            borderBottom: '2px solid #e2e8f0',
                            minHeight: '52px !important',
                            maxHeight: '52px !important',
                        },
                        '& .MuiDataGrid-columnHeader': {
                            '&:focus, &:focus-within': { outline: 'none' },
                        },
                        '& .MuiDataGrid-row': {
                            transition: 'background-color 0.15s ease',
                            '&:nth-of-type(even)': {
                                backgroundColor: '#fafbfc',
                            },
                            '&:hover': {
                                backgroundColor: '#f1f5f9 !important',
                            },
                            '&.Mui-selected': {
                                backgroundColor: '#ebf5fa !important',
                                '&:hover': {
                                    backgroundColor: '#dbeef7 !important',
                                },
                            },
                        },
                        '& .MuiDataGrid-cell': {
                            borderBottom: '1px solid #f1f5f9',
                            fontSize: '14px',
                            color: '#334155',
                            overflow: 'visible',
                            whiteSpace: 'normal',
                            lineHeight: 'normal',
                            wordWrap: 'break-word',
                            textOverflow: 'clip',
                            '&:focus': { outline: 'none' },
                        },
                        '& .MuiDataGrid-virtualScroller': {
                            border: 'none',
                        },
                        '& .MuiDataGrid-main': {
                            border: 'none',
                        },
                        '& .MuiDataGrid-footerContainer': {
                            borderTop: '1px solid #e2e8f0',
                            backgroundColor: '#f8fafc',
                            minHeight: 56,
                        },
                        '& .MuiTablePagination-root': {
                            color: '#64748b',
                            fontSize: '13px',
                        },
                        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                            marginBottom: 0,
                        },
                        '& .MuiTablePagination-select': {
                            fontSize: '13px',
                            borderRadius: '6px',
                            border: '1px solid #e2e8f0',
                        },
                        '& .MuiIconButton-root': {
                            color: '#64748b',
                            '&:hover': {
                                backgroundColor: '#f1f5f9',
                                color: '#475569',
                            },
                        },
                        '&.MuiDataGrid-root .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderTitleContainer': {
                            pl: 1,
                        },
                    }}
                />
            {<AddEditCustomerUsers
                handleClose={handleClose}
                Open={Open}
                UsersBL={Formdata}
                handleSubmit={handleSubmit}
                setSelectedOption={setSelectedOption}
                selectedOptions={selectedOptions}
                initValues={initialUserData}
                SelectedRoles={SelectedRoles}
                setSelectedRoles={setSelectedRoles}
                ClientUserRoles={baseClientUserRolesForUi}
                // imageProfile ={imageProfile}
                // setImageProfile={setImageProfile}

            ></AddEditCustomerUsers>}

            </Box>
        </>
    )
}